import { apiFetcher } from '~/apis/api-fetcher';

export type KeywordsRankingsRequest = {
  size: number;
  gender?: 'A' | 'W' | 'M';
  age?: number;
};
type Response = {
  data: KeywordsRanking[];
};

export type KeywordsRanking = {
  keyword: string;
  ranking: string;
  shift?: 'UP' | 'DOWN' | 'NEW' | 'NONE';
};

export const getKeywordsRankings = (params: KeywordsRankingsRequest) =>
  apiFetcher.get<Response>('/api/search/mercari/v1/keywords/rankings', params);
